export const DCC_KEY = 'currency-conversion';

export const DCC_CONFIG_DEFAULT_CHANNEL = 'CNP';
export const DCC_CONFIG_DEFAULT_ENTRY_MODE = 'ECOM';
export const DCC_CONFIG_DEFAULT_TRANSACTION_TYPE = 'SALE';

export const DCC_AVAILABILITY_STATUS_KEY: string = "dccAvailabilityStatus";